import store from '../../../store';

export default async documentId => {
	const question = await store.model.Document.findById(documentId, {
		include: [
			{
				relation: 'refFiles',
				scope: {
					// fields: { id: true, description: true, filesize: true, docFileId: true },
					include: ['docFile']
				},
			},
			{
				relation: 'refLinks',
				scope: {
					include: [
						{
							relation: 'child',
							scope: {
								include: [
									{
										relation: 'refFiles',
										scope: {
											// fields: { id: true, name: true, description: true, filesize: true, docFileId: true },
											include: ['docFile']
										},
									},
								],
							}
						},
					],
				}
			}
		],
	});
	
	const refFiles = [];
	refFiles.push(...question.refFiles());
	for (let _refLink of question.refLinks()) {
		refFiles.push(..._refLink.child.refFiles());
	}
	const filtered = refFiles.filter(file => !!file.docFile);
	const files = filtered.map(f => ({ id: f.docFile.id, name: f.docFile.contents, url: f.docFile.downloadFile('contents') }));
	
	for (let file of files) {
		console.log('-- file', file);
	}
	
	return {
		id: documentId,
		name: question.name,
		files,
	};
};
